import { render, staticRenderFns } from "./index.vue?vue&type=template&id=dd187758&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=dd187758&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd187758",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TimeCountdown: require('/drone/src/components/TimeCountdown/index.vue').default})
